<div class="fiat-transaction-list-item-container">
  <div class="list-item" [ngClass]="{ 'has-share-button': showShareButton }">
    @if (transaction) {
      <div
        class="bp-modal mod-tx-list"
			[ngClass]="{
				'mod-full': canOpen,
				'mod-lg': !canOpen,
				'mod-hover': canOpen && !isActivityOrHistory()
			}"
        [class.focusable]="focusable"
        (keydown.enter)="focusable && toggle()"
        [tabIndex]="focusable ? 0 : -1">
        @if (isIndexTx()) {
          <div class="modal-grey-background">
            <index-transaction-list-header
              (click)="toggle()"
              [activity]="activity"
              [canOpen]="canOpen"
              (closeEmitter)="closeEmitter.emit()"
              [transaction]="transaction"
              [isWidget]="isWidget">
            </index-transaction-list-header>
            @if (!canOpen) {
              <index-transaction-list-detail
                [showShareButton]="showShareButton"
                [transaction]="transaction"
                >
              </index-transaction-list-detail>
            }
          </div>
        } @else {
          <fiat-transaction-list-header
            (click)="toggle()"
            [activity]="activity"
            [canOpen]="canOpen"
            (closeEmitter)="closeEmitter.emit()"
            [transaction]="transaction"
            [isWidget]="isWidget">
          </fiat-transaction-list-header>
          @if (!canOpen) {
            <fiat-transaction-list-detail
              (closeEmitter)="closeEmitter.emit($event)"
              [transaction]="transaction"
            ></fiat-transaction-list-detail>
          }
          <actions-bar [transaction]="transaction" [canOpen]="canOpen"></actions-bar>
          @if (!canOpen) {
            <fiat-transaction-list-footer
              [showShareButton]="showShareButton"
              [transaction]="transaction"
              [PID]="pid"
              [balance]="balance | async">
            </fiat-transaction-list-footer>
          }
        }
      </div>
    }
  </div>
  @if (showShareButton) {
    @if (transaction.canBeShared() && canOpen && !isEarnOnFiat) {
      <share-button
        class="share-button-list-item"
      [transaction]="transaction"></share-button>
    }
  }
</div>
